// Pro Forma data from Google Sheets
// Everything pre March 2026 is ACTUAL, March 2026+ is PROJECTION

export interface MonthData {
  month: string; // "Oct-24", "Nov-24", etc.
  date: string; // "2024-10" for sorting
  isProjection: boolean;

  // Sales Metrics
  aesNeeded?: number;
  aesActual?: number;
  locationsPerAE?: number;
  locationsNeeded?: number;
  mrrAddedQuota?: number;
  arrAddedQuota?: number;

  // Income
  monthlyMRRGrowthPct?: number;
  monthlySMSIncome?: number;
  monthlyRecurring?: number;
  seasonalMisc?: number;
  setupFees?: number;
  totalMonthlyIncome?: number;
  arr?: number;
  arrPlus?: number;

  // COGS
  customerSuccessTeam?: number;
  messagingCosts?: number;
  stripeCharges?: number;
  serverCosts?: number;
  totalCOGS?: number;

  // Profit
  profit?: number;
  grossMargin?: number;

  // Expenses
  misc?: number;
  stateTaxes?: number;
  gAndA?: number;
  rAndD?: number;
  salesTeam?: number;
  marketingTotal?: number;
  smTotal?: number;
  totalExpenses?: number;

  // Net Operating Income
  netOperatingIncome?: number;

  // Growth Metrics
  newARRAdded?: number;
  arrGrowthRate?: number;
  newMRRAdded?: number;
  locationsAddedGross?: number;

  // Efficiency Metrics
  cac?: number;
  ltv?: number;
  ltvCac?: number;
  cacRecoveryMonths?: number;
  magicNumber?: number;

  // Hiring Metrics
  ftes?: number;
  arrPerFTE?: number;
}

export const months: MonthData[] = [
  {
    month: "Oct 24",
    date: "2024-10",
    isProjection: false,
    aesActual: 2,
    locationsNeeded: 12,
    mrrAddedQuota: 4400,
    arrAddedQuota: 52800,
    monthlySMSIncome: 59876,
    monthlyRecurring: 123500,
    seasonalMisc: 831,
    setupFees: 2402,
    totalMonthlyIncome: 186609,
    arr: 1482000,
    arrPlus: 2239313,
    customerSuccessTeam: 18500,
    messagingCosts: 55000,
    stripeCharges: 4956,
    totalExpenses: undefined,
    misc: 14500,
    gAndA: undefined,
    rAndD: undefined,
    salesTeam: 34900,
    marketingTotal: 6000,
    netOperatingIncome: undefined,
  },
  {
    month: "Nov 24",
    date: "2024-11",
    isProjection: false,
    aesActual: 2,
    locationsNeeded: 15,
    mrrAddedQuota: 4400,
    arrAddedQuota: 52800,
    monthlySMSIncome: 61313,
    monthlyRecurring: 134119,
    seasonalMisc: 1283,
    setupFees: 0,
    totalMonthlyIncome: 196715,
    arr: 1609428,
    arrPlus: 2360578,
    customerSuccessTeam: 18500,
    messagingCosts: 56540,
    stripeCharges: 5414,
    salesTeam: 40600,
    marketingTotal: 6000,
    rAndD: 41800,
  },
  {
    month: "Dec 24",
    date: "2024-12",
    isProjection: false,
    aesActual: 2,
    locationsNeeded: 22,
    mrrAddedQuota: 6500,
    arrAddedQuota: 78000,
    monthlySMSIncome: 78303,
    monthlyRecurring: 159756,
    seasonalMisc: 1400,
    setupFees: 0,
    totalMonthlyIncome: 239459,
    arr: 1917072,
    arrPlus: 2873508,
    customerSuccessTeam: 18500,
    messagingCosts: 58123,
    stripeCharges: 5685,
    salesTeam: 45000,
    marketingTotal: 6000,
    smTotal: 51000,
  },
  {
    month: "Jan 25",
    date: "2025-01",
    isProjection: false,
    aesActual: 3,
    locationsNeeded: 35,
    mrrAddedQuota: 13912,
    arrAddedQuota: 120000,
    monthlySMSIncome: 61853,
    monthlyRecurring: 173668,
    seasonalMisc: 4062,
    setupFees: 500,
    totalMonthlyIncome: 240083,
    arr: 2084016,
    arrPlus: 2880996,
    customerSuccessTeam: 15500,
    messagingCosts: 63711,
    stripeCharges: 6432,
    serverCosts: 11344,
    totalCOGS: 96987,
    profit: 143096,
    grossMargin: 59.6,
    gAndA: 41700,
    rAndD: 43070,
    salesTeam: 57858,
    marketingTotal: 5503,
    smTotal: 63361,
    totalExpenses: 148131,
    netOperatingIncome: -5035,
    newARRAdded: 166944,
    arrGrowthRate: 8.71,
    newMRRAdded: 13912,
    locationsAddedGross: 42,
    cac: 1508.61,
    ltv: 7572.53,
    ltvCac: 5.02,
    cacRecoveryMonths: 4.01,
    magicNumber: 0.15,
    ftes: 11,
    arrPerFTE: 261909,
  },
  {
    month: "Feb 25",
    date: "2025-02",
    isProjection: false,
    aesActual: 3,
    locationsNeeded: 25,
    mrrAddedQuota: 7355,
    arrAddedQuota: 155000,
    monthlySMSIncome: 69279,
    monthlyRecurring: 181023,
    seasonalMisc: 0,
    setupFees: 500,
    totalMonthlyIncome: 250802,
    arr: 2172276,
    arrPlus: 3009624,
    customerSuccessTeam: 17315,
    messagingCosts: 69913,
    stripeCharges: 6408,
    serverCosts: 12297,
    totalCOGS: 105933,
    profit: 144869,
    grossMargin: 57.76,
    gAndA: 41776,
    rAndD: 42218,
    salesTeam: 60206,
    marketingTotal: 4619,
    smTotal: 64825,
    totalExpenses: 148819,
    netOperatingIncome: -3950,
    newARRAdded: 88260,
    arrGrowthRate: 4.24,
    newMRRAdded: 7355,
    locationsAddedGross: 53,
    cac: 1223.11,
    ltv: 7338.70,
    ltvCac: 6.00,
    cacRecoveryMonths: 3.25,
    magicNumber: 2.03,
    ftes: 13,
    arrPerFTE: 231510,
  },
  {
    month: "Mar 25",
    date: "2025-03",
    isProjection: false,
    aesActual: 3,
    locationsNeeded: 92,
    mrrAddedQuota: 27598,
    arrAddedQuota: 175000,
    monthlySMSIncome: 45131,
    monthlyRecurring: 208621,
    seasonalMisc: 0,
    setupFees: 3600,
    totalMonthlyIncome: 257352,
    arr: 2503452,
    arrPlus: 3088224,
    customerSuccessTeam: 31010,
    messagingCosts: 54882,
    stripeCharges: 9186,
    serverCosts: 11573,
    totalCOGS: 106651,
    profit: 150701,
    grossMargin: 58.56,
    gAndA: 45142,
    rAndD: 44212,
    salesTeam: 69178,
    marketingTotal: 4694,
    smTotal: 73872,
    totalExpenses: 163226,
    netOperatingIncome: -12525,
    newARRAdded: 331176,
    arrGrowthRate: 15.25,
    newMRRAdded: 27598,
    locationsAddedGross: 72,
    cac: 1026.00,
    ltv: 7439.83,
    ltvCac: 7.25,
    cacRecoveryMonths: 2.72,
    magicNumber: 1.21,
    ftes: 14,
    arrPerFTE: 220587,
  },
  {
    month: "Apr 25",
    date: "2025-04",
    isProjection: false,
    aesActual: 4,
    locationsNeeded: 86,
    mrrAddedQuota: 25858,
    arrAddedQuota: 180000,
    monthlySMSIncome: 62552,
    monthlyRecurring: 234479,
    seasonalMisc: 0,
    setupFees: 500,
    totalMonthlyIncome: 297531,
    arr: 2813748,
    arrPlus: 3570372,
    customerSuccessTeam: 29678,
    messagingCosts: 69544,
    stripeCharges: 7242,
    serverCosts: 13077,
    totalCOGS: 119541,
    profit: 177990,
    grossMargin: 59.82,
    gAndA: 49740,
    rAndD: 53321,
    salesTeam: 83723,
    marketingTotal: 10242,
    smTotal: 93965,
    totalExpenses: 197026,
    netOperatingIncome: -19036,
    newARRAdded: 310296,
    arrGrowthRate: 12.39,
    newMRRAdded: 25858,
    locationsAddedGross: 49,
    cac: 1917.65,
    ltv: 7600.43,
    ltvCac: 3.96,
    cacRecoveryMonths: 5.09,
    magicNumber: 6.53,
    ftes: 16,
    arrPerFTE: 223148,
  },
  {
    month: "May 25",
    date: "2025-05",
    isProjection: false,
    aesActual: 4,
    locationsNeeded: 117,
    mrrAddedQuota: 35000,
    arrAddedQuota: 200000,
    monthlySMSIncome: 52927,
    monthlyRecurring: 269479,
    seasonalMisc: 0,
    setupFees: 8077,
    totalMonthlyIncome: 330483,
    arr: 3233748,
    arrPlus: 3965796,
    customerSuccessTeam: 37180,
    messagingCosts: 63927,
    stripeCharges: 8102,
    serverCosts: 13163,
    totalCOGS: 122372,
    profit: 208111,
    grossMargin: 62.97,
    gAndA: 43771,
    rAndD: 55873,
    salesTeam: 92133,
    marketingTotal: 10409,
    smTotal: 102542,
    totalExpenses: 202186,
    netOperatingIncome: 5925,
    newARRAdded: 420000,
    arrGrowthRate: 14.93,
    newMRRAdded: 35000,
    locationsAddedGross: 58,
    cac: 1767.97,
    ltv: 8000.56,
    ltvCac: 4.53,
    cacRecoveryMonths: 4.69,
    magicNumber: 4.21,
    ftes: 18,
    arrPerFTE: 220322,
  },
  {
    month: "Jun 25",
    date: "2025-06",
    isProjection: false,
    aesActual: 4,
    locationsNeeded: 54,
    mrrAddedQuota: 16160,
    arrAddedQuota: 210000,
    monthlySMSIncome: 90677,
    monthlyRecurring: 285639,
    seasonalMisc: 0,
    setupFees: 9134,
    totalMonthlyIncome: 385450,
    arr: 3427668,
    arrPlus: 4625399,
    customerSuccessTeam: 39543,
    messagingCosts: 79667,
    stripeCharges: 8407,
    serverCosts: 14364,
    totalCOGS: 141981,
    profit: 243469,
    grossMargin: 63.16,
    gAndA: 69110,
    rAndD: 55283,
    salesTeam: 87408,
    marketingTotal: 12168,
    smTotal: 99576,
    totalExpenses: 223969,
    netOperatingIncome: 19500,
    newARRAdded: 193920,
    arrGrowthRate: 6.00,
    newMRRAdded: 16160,
    locationsAddedGross: 58,
    cac: 1716.83,
    ltv: 8025.10,
    ltvCac: 4.67,
    cacRecoveryMonths: 4.56,
    magicNumber: 6.43,
    ftes: 20,
    arrPerFTE: 231270,
  },
  {
    month: "Jul 25",
    date: "2025-07",
    isProjection: false,
    aesActual: 5,
    locationsNeeded: 86,
    mrrAddedQuota: 25740,
    arrAddedQuota: 230000,
    monthlySMSIncome: 91224,
    monthlyRecurring: 311379,
    seasonalMisc: 0,
    setupFees: 3950,
    totalMonthlyIncome: 406553,
    arr: 3736548,
    arrPlus: 4878636,
    customerSuccessTeam: 43988,
    messagingCosts: 92255,
    stripeCharges: 10617,
    serverCosts: 17075,
    totalCOGS: 163935,
    profit: 242618,
    grossMargin: 59.68,
    gAndA: 60569,
    rAndD: 52407,
    salesTeam: 90962,
    marketingTotal: 25353,
    smTotal: 116315,
    totalExpenses: 229291,
    netOperatingIncome: 13327,
    newARRAdded: 308880,
    arrGrowthRate: 9.01,
    newMRRAdded: 25740,
    locationsAddedGross: 48,
    cac: 2423.23,
    ltv: 7581.94,
    ltvCac: 3.13,
    cacRecoveryMonths: 6.43,
    magicNumber: 2.54,
    ftes: 20,
    arrPerFTE: 243932,
  },
  {
    month: "Aug 25",
    date: "2025-08",
    isProjection: false,
    aesActual: 6,
    locationsNeeded: 102,
    mrrAddedQuota: 30560,
    arrAddedQuota: 250000,
    monthlySMSIncome: 77875,
    monthlyRecurring: 341939,
    seasonalMisc: 0,
    setupFees: 11700,
    totalMonthlyIncome: 431514,
    arr: 4103268,
    arrPlus: 5178168,
    customerSuccessTeam: 49026,
    messagingCosts: 90192,
    stripeCharges: 10256,
    serverCosts: 19547,
    totalCOGS: 169021,
    profit: 262493,
    grossMargin: 60.83,
    gAndA: 58785,
    rAndD: 47298,
    salesTeam: 102143,
    marketingTotal: 18692,
    smTotal: 120835,
    totalExpenses: 226918,
    netOperatingIncome: 35575,
    newARRAdded: 366720,
    arrGrowthRate: 9.81,
    newMRRAdded: 30560,
    locationsAddedGross: 73,
    cac: 1655.27,
    ltv: 7728.54,
    ltvCac: 4.67,
    cacRecoveryMonths: 4.39,
    magicNumber: 2.58,
    ftes: 22,
    arrPerFTE: 235371,
  },
  {
    month: "Sep 25",
    date: "2025-09",
    isProjection: false,
    aesActual: 6,
    locationsNeeded: 83,
    mrrAddedQuota: 25000,
    arrAddedQuota: 300000,
    monthlySMSIncome: 85084,
    monthlyRecurring: 359786,
    seasonalMisc: 0,
    setupFees: 16565,
    totalMonthlyIncome: 461435,
    arr: 4317432,
    arrPlus: 5537220,
    customerSuccessTeam: 53315,
    messagingCosts: 98667,
    stripeCharges: 12757,
    serverCosts: 19378,
    totalCOGS: 184117,
    profit: 277318,
    grossMargin: 60.10,
    gAndA: 81546,
    rAndD: 41776,
    salesTeam: 116625,
    marketingTotal: 20943,
    smTotal: 137568,
    totalExpenses: 260890,
    netOperatingIncome: 16428,
    newARRAdded: 214164,
    arrGrowthRate: 5.22,
    newMRRAdded: 17847,
    locationsAddedGross: 75,
    cac: 1834.24,
    ltv: 7635.58,
    ltvCac: 4.16,
    cacRecoveryMonths: 4.87,
    magicNumber: 2.97,
    ftes: 25,
    arrPerFTE: 221489,
  },
  {
    month: "Oct 25",
    date: "2025-10",
    isProjection: false,
    aesActual: 6,
    locationsNeeded: 83,
    mrrAddedQuota: 25000,
    arrAddedQuota: 300000,
    monthlySMSIncome: 64314,
    monthlyRecurring: 386750,
    seasonalMisc: 0,
    setupFees: 13920,
    totalMonthlyIncome: 464984,
    arr: 4641000,
    arrPlus: 5579808,
    customerSuccessTeam: 73956,
    messagingCosts: 87827,
    stripeCharges: 10955,
    serverCosts: 20598,
    totalCOGS: 193336,
    profit: 271648,
    grossMargin: 58.42,
    gAndA: 58506,
    rAndD: 48322,
    salesTeam: 136944,
    marketingTotal: 25749,
    smTotal: 162693,
    totalExpenses: 269521,
    netOperatingIncome: 2127,
    newARRAdded: 323568,
    arrGrowthRate: 7.49,
    newMRRAdded: 26964,
    locationsAddedGross: 119,
    cac: 1367.17,
    ltv: 7422.38,
    ltvCac: 5.43,
    cacRecoveryMonths: 3.63,
    magicNumber: 0.31,
    ftes: 26,
    arrPerFTE: 214608,
  },
  {
    month: "Nov 25",
    date: "2025-11",
    isProjection: false,
    aesActual: 6,
    locationsNeeded: 73,
    mrrAddedQuota: 22000,
    arrAddedQuota: 264000,
    monthlySMSIncome: 72734,
    monthlyRecurring: 430424,
    seasonalMisc: 0,
    setupFees: 14000,
    totalMonthlyIncome: 517158,
    arr: 5165088,
    arrPlus: 6205896,
    customerSuccessTeam: 72949,
    messagingCosts: 90913,
    stripeCharges: 11793,
    serverCosts: 22828,
    totalCOGS: 198483,
    profit: 318675,
    grossMargin: 61.62,
    gAndA: 88255,
    rAndD: 53167,
    salesTeam: 127684,
    marketingTotal: 32641,
    smTotal: 160325,
    totalExpenses: 301747,
    netOperatingIncome: 16928,
    newARRAdded: 524088,
    arrGrowthRate: 11.29,
    newMRRAdded: 43674,
    locationsAddedGross: 121,
    cac: 1325.00,
    ltv: 7828.88,
    ltvCac: 5.91,
    cacRecoveryMonths: 3.52,
    magicNumber: 3.85,
    ftes: 28,
    arrPerFTE: 221639,
  },
  {
    month: "Dec 25",
    date: "2025-12",
    isProjection: false,
    aesActual: 6,
    locationsNeeded: 167,
    mrrAddedQuota: 50003,
    arrAddedQuota: 600036,
    monthlySMSIncome: 150906,
    monthlyRecurring: 480427,
    seasonalMisc: 0,
    setupFees: 11607,
    totalMonthlyIncome: 642940,
    arr: 5765124,
    arrPlus: 7715280,
    customerSuccessTeam: 89917,
    messagingCosts: 121507,
    stripeCharges: 16686,
    serverCosts: 26429,
    totalCOGS: 254539,
    profit: 388401,
    grossMargin: 60.41,
    gAndA: 86685,
    rAndD: 103486,
    salesTeam: 141848,
    marketingTotal: 31781,
    smTotal: 173629,
    totalExpenses: 363800,
    netOperatingIncome: 24601,
    newARRAdded: 600036,
    arrGrowthRate: 11.62,
    newMRRAdded: 50003,
    locationsAddedGross: 167,
    cac: 1041.71,
    ltv: 7675.11,
    ltvCac: 7.37,
    cacRecoveryMonths: 2.77,
    magicNumber: 9.41,
    ftes: 29,
    arrPerFTE: 266044,
  },
  {
    month: "Jan 26",
    date: "2026-01",
    isProjection: false,
    aesActual: 7,
    locationsNeeded: 115,
    mrrAddedQuota: 34394,
    arrAddedQuota: 412728,
    monthlySMSIncome: 104389,
    monthlyRecurring: 514821,
    seasonalMisc: 1500,
    setupFees: 13850,
    totalMonthlyIncome: 634560,
    arr: 6177852,
    arrPlus: 7614720,
    customerSuccessTeam: 84595,
    messagingCosts: 129890,
    stripeCharges: 17306,
    serverCosts: 23868,
    totalCOGS: 255659,
    profit: 378901,
    grossMargin: 59.71,
    gAndA: 99758,
    rAndD: 69672,
    salesTeam: 125928,
    marketingTotal: 33263,
    smTotal: 159191,
    totalExpenses: 328621,
    netOperatingIncome: 50280,
    newARRAdded: 412728,
    arrGrowthRate: 7.16,
    newMRRAdded: 34394,
    locationsAddedGross: 76,
    cac: 2094.62,
    ltv: 7586.26,
    ltvCac: 3.62,
    cacRecoveryMonths: 5.56,
    magicNumber: -0.58,
    ftes: 32,
    arrPerFTE: 237960,
  },
  {
    month: "Feb 26",
    date: "2026-02",
    isProjection: false,
    aesActual: 7,
    locationsNeeded: 120,
    mrrAddedQuota: 19701,
    arrAddedQuota: 236412,
    monthlySMSIncome: 104830,
    monthlyRecurring: 534522,
    seasonalMisc: 267,
    setupFees: 14694,
    totalMonthlyIncome: 654313,
    arr: 6414264,
    arrPlus: 7851756,
    customerSuccessTeam: 87131,
    messagingCosts: 129879,
    stripeCharges: 17825,
    serverCosts: 21312,
    totalCOGS: 256147,
    profit: 398166,
    grossMargin: 60.85,
    gAndA: 84423,
    rAndD: 71457,
    salesTeam: 126612,
    marketingTotal: 37423,
    smTotal: 164035,
    totalExpenses: 319915,
    netOperatingIncome: 78251,
    newARRAdded: 236412,
    arrGrowthRate: 3.83,
    newMRRAdded: 19701,
    locationsAddedGross: 103,
    cac: 1592.57,
    ltv: 7731.31,
    ltvCac: 4.85,
    cacRecoveryMonths: 4.23,
    magicNumber: 1.49,
    ftes: 33,
    arrPerFTE: 237932,
  },
  // === PROJECTIONS START HERE (Mar 26+) ===
  {
    month: "Mar 26",
    date: "2026-03",
    isProjection: true,
    aesActual: 8,
    locationsNeeded: 101,
    mrrAddedQuota: 30263,
    arrAddedQuota: 363154,
    monthlySMSIncome: 74494,
    monthlyRecurring: 564785,
    seasonalMisc: 50,
    setupFees: 13484,
    totalMonthlyIncome: 652813,
    arr: 6777418,
    arrPlus: 7833754,
    customerSuccessTeam: 86387,
    messagingCosts: 105877,
    stripeCharges: 22687,
    serverCosts: 16161,
    totalCOGS: 231112,
    profit: 421701,
    grossMargin: 64.60,
    gAndA: 85336,
    rAndD: 72835,
    salesTeam: 157614,
    marketingTotal: 40034,
    smTotal: 197648,
    totalExpenses: 355819,
    netOperatingIncome: 65882,
    newARRAdded: 363154,
    arrGrowthRate: 5.66,
    newMRRAdded: 30263,
    locationsAddedGross: 78,
    cac: 2533.95,
    ltv: 8207.11,
    ltvCac: 3.24,
    cacRecoveryMonths: 6.73,
    magicNumber: -0.11,
    ftes: 33,
    arrPerFTE: 237386,
  },
  {
    month: "Apr 26",
    date: "2026-04",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 5.60,
    locationsNeeded: 105,
    mrrAddedQuota: 31628,
    arrAddedQuota: 379535,
    monthlySMSIncome: 85000,
    monthlyRecurring: 596413,
    seasonalMisc: 50,
    setupFees: 14239,
    totalMonthlyIncome: 695702,
    arr: 7156953,
    arrPlus: 8348422,
    customerSuccessTeam: 85000,
    messagingCosts: 106936,
    stripeCharges: 23368,
    serverCosts: 17161,
    totalCOGS: 232464,
    profit: 463238,
    grossMargin: 66.59,
    gAndA: 85000,
    rAndD: 95000,
    salesTeam: 135000,
    marketingTotal: 43000,
    totalExpenses: 358000,
    netOperatingIncome: 105238,
    newARRAdded: 379535,
    arrGrowthRate: 5.60,
    newMRRAdded: 31628,
    locationsAddedGross: 103,
    cac: 1728.16,
    ltv: 8459.71,
    ltvCac: 4.90,
    cacRecoveryMonths: 4.59,
    magicNumber: 2.60,
    ftes: 33,
    arrPerFTE: 252982,
  },
  {
    month: "May 26",
    date: "2026-05",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 5.40,
    locationsNeeded: 107,
    mrrAddedQuota: 32206,
    arrAddedQuota: 386475,
    monthlySMSIncome: 80000,
    monthlyRecurring: 628619,
    seasonalMisc: 50,
    setupFees: 15008,
    totalMonthlyIncome: 723677,
    arr: 7543429,
    arrPlus: 8684125,
    customerSuccessTeam: 91000,
    messagingCosts: 108005,
    stripeCharges: 24069,
    serverCosts: 18161,
    totalCOGS: 241235,
    profit: 482442,
    grossMargin: 66.67,
    gAndA: 85000,
    rAndD: 95000,
    salesTeam: 135000,
    marketingTotal: 46000,
    totalExpenses: 361000,
    netOperatingIncome: 121442,
    newARRAdded: 386475,
    arrGrowthRate: 5.40,
    newMRRAdded: 32206,
    locationsAddedGross: 103,
    cac: 1757.28,
    ltv: 8469.84,
    ltvCac: 4.82,
    cacRecoveryMonths: 4.67,
    magicNumber: 1.89,
    ftes: 33,
    arrPerFTE: 263155,
  },
  {
    month: "Jun 26",
    date: "2026-06",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 5.15,
    locationsNeeded: 108,
    mrrAddedQuota: 32374,
    arrAddedQuota: 388487,
    monthlySMSIncome: 80000,
    monthlyRecurring: 660993,
    seasonalMisc: 50,
    setupFees: 15781,
    totalMonthlyIncome: 756824,
    arr: 7931915,
    arrPlus: 9081886,
    customerSuccessTeam: 91000,
    messagingCosts: 109085,
    stripeCharges: 24791,
    serverCosts: 19161,
    totalCOGS: 244037,
    profit: 512787,
    grossMargin: 67.76,
    gAndA: 85000,
    rAndD: 95000,
    salesTeam: 135000,
    marketingTotal: 48000,
    totalExpenses: 363000,
    netOperatingIncome: 149787,
    newARRAdded: 388487,
    arrGrowthRate: 5.15,
    newMRRAdded: 32374,
    locationsAddedGross: 103,
    cac: 1776.70,
    ltv: 8608.29,
    ltvCac: 4.85,
    cacRecoveryMonths: 4.72,
    magicNumber: 2.20,
    ftes: 33,
    arrPerFTE: 275209,
  },
  {
    month: "Jul 26",
    date: "2026-07",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 4.00,
    locationsNeeded: 88,
    mrrAddedQuota: 26440,
    arrAddedQuota: 317277,
    monthlySMSIncome: 90000,
    monthlyRecurring: 687433,
    seasonalMisc: 50,
    setupFees: 16412,
    totalMonthlyIncome: 793895,
    arr: 8249192,
    arrPlus: 9526738,
    customerSuccessTeam: 91000,
    messagingCosts: 110176,
    stripeCharges: 25534,
    serverCosts: 20161,
    totalCOGS: 246871,
    profit: 547023,
    grossMargin: 68.90,
    gAndA: 85000,
    rAndD: 95000,
    salesTeam: 135000,
    marketingTotal: 50000,
    totalExpenses: 365000,
    netOperatingIncome: 182023,
    cac: 1796.12,
    ltv: 8754.22,
    ltvCac: 4.87,
    cacRecoveryMonths: 4.77,
    magicNumber: 2.43,
    ftes: 33,
    arrPerFTE: 288689,
  },
  {
    month: "Aug 26",
    date: "2026-08",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 4.81,
    locationsNeeded: 110,
    mrrAddedQuota: 33066,
    arrAddedQuota: 396786,
    monthlySMSIncome: 90000,
    monthlyRecurring: 720498,
    seasonalMisc: 50,
    setupFees: 17202,
    totalMonthlyIncome: 827750,
    arr: 8645978,
    arrPlus: 9932997,
    customerSuccessTeam: 91000,
    messagingCosts: 111278,
    stripeCharges: 26300,
    serverCosts: 21161,
    totalCOGS: 249739,
    profit: 578011,
    grossMargin: 69.83,
    gAndA: 85000,
    rAndD: 95000,
    salesTeam: 135000,
    marketingTotal: 52000,
    totalExpenses: 367000,
    netOperatingIncome: 211011,
    cac: 1815.53,
    ltv: 8871.79,
    ltvCac: 4.89,
    cacRecoveryMonths: 4.82,
    magicNumber: 2.20,
    ftes: 33,
    arrPerFTE: 301000,
  },
  {
    month: "Sep 26",
    date: "2026-09",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 4.60,
    locationsNeeded: 110,
    mrrAddedQuota: 33143,
    arrAddedQuota: 397715,
    monthlySMSIncome: 90000,
    monthlyRecurring: 753641,
    seasonalMisc: 50,
    setupFees: 17993,
    totalMonthlyIncome: 861684,
    arr: 9043693,
    arrPlus: 10340207,
    customerSuccessTeam: 91000,
    messagingCosts: 112391,
    stripeCharges: 27089,
    serverCosts: 22161,
    totalCOGS: 252641,
    profit: 609043,
    grossMargin: 70.68,
    gAndA: 85000,
    rAndD: 95000,
    salesTeam: 135000,
    marketingTotal: 54000,
    totalExpenses: 369000,
    netOperatingIncome: 240043,
    newMRRAdded: 33143,
    cac: 1834.95,
    ltv: 8979.96,
    ltvCac: 4.89,
    cacRecoveryMonths: 4.87,
    magicNumber: 2.18,
    ftes: 33,
    arrPerFTE: 313340,
  },
  {
    month: "Oct 26",
    date: "2026-10",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 4.40,
    locationsNeeded: 111,
    mrrAddedQuota: 33160,
    arrAddedQuota: 397922,
    monthlySMSIncome: 90000,
    monthlyRecurring: 786801,
    seasonalMisc: 50,
    setupFees: 18785,
    totalMonthlyIncome: 895636,
    arr: 9441615,
    arrPlus: 10747630,
    stateTaxes: 35000,
    customerSuccessTeam: 91000,
    messagingCosts: 113514,
    stripeCharges: 27902,
    serverCosts: 23161,
    totalCOGS: 255578,
    profit: 640058,
    grossMargin: 71.46,
    gAndA: 85000,
    rAndD: 105000,
    salesTeam: 135000,
    marketingTotal: 56000,
    totalExpenses: 416000,
    netOperatingIncome: 224058,
    newMRRAdded: 33160,
  },
  {
    month: "Nov 26",
    date: "2026-11",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 4.20,
    locationsNeeded: 110,
    mrrAddedQuota: 33046,
    arrAddedQuota: 396548,
    monthlySMSIncome: 110000,
    monthlyRecurring: 819847,
    seasonalMisc: 50,
    setupFees: 19574,
    totalMonthlyIncome: 949470,
    arr: 9838163,
    arrPlus: 11393645,
    customerSuccessTeam: 91000,
    messagingCosts: 114650,
    stripeCharges: 28739,
    serverCosts: 24161,
    totalCOGS: 258550,
    profit: 690921,
    grossMargin: 72.77,
    gAndA: 85000,
    rAndD: 105000,
    salesTeam: 135000,
    marketingTotal: 58000,
    totalExpenses: 383000,
    netOperatingIncome: 307921,
    newMRRAdded: 33046,
  },
  {
    month: "Dec 26",
    date: "2026-12",
    isProjection: true,
    aesActual: 9,
    monthlyMRRGrowthPct: 4.05,
    locationsNeeded: 111,
    mrrAddedQuota: 33204,
    arrAddedQuota: 398446,
    monthlySMSIncome: 140000,
    monthlyRecurring: 853051,
    seasonalMisc: 50,
    setupFees: 20366,
    totalMonthlyIncome: 1013467,
    arr: 10236609,
    arrPlus: 12161604,
    customerSuccessTeam: 91000,
    messagingCosts: 115796,
    stripeCharges: 29601,
    serverCosts: 25161,
    totalCOGS: 261558,
    profit: 751909,
    grossMargin: 74.19,
    gAndA: 85000,
    rAndD: 105000,
    salesTeam: 135000,
    marketingTotal: 60000,
    totalExpenses: 385000,
    netOperatingIncome: 366909,
    newMRRAdded: 33204,
  },
  {
    month: "Jan 27",
    date: "2027-01",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 4.00,
    locationsNeeded: 114,
    mrrAddedQuota: 34122,
    arrAddedQuota: 409464,
    monthlySMSIncome: 90000,
    monthlyRecurring: 887173,
    seasonalMisc: 50,
    setupFees: 21181,
    totalMonthlyIncome: 998404,
    arr: 10646073,
    arrPlus: 11980844,
    customerSuccessTeam: 73000,
    messagingCosts: 119038,
    stripeCharges: 30489,
    serverCosts: 26161,
    totalCOGS: 248689,
    profit: 749715,
    grossMargin: 75.09,
    gAndA: 50000,
    rAndD: 80000,
    salesTeam: 120000,
    marketingTotal: 18000,
    totalExpenses: 268000,
    netOperatingIncome: 481715,
  },
  {
    month: "Feb 27",
    date: "2027-02",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.90,
    locationsNeeded: 115,
    mrrAddedQuota: 34600,
    arrAddedQuota: 415197,
    monthlySMSIncome: 90000,
    monthlyRecurring: 921773,
    seasonalMisc: 50,
    setupFees: 22007,
    totalMonthlyIncome: 1033829,
    arr: 11061270,
    arrPlus: 12405953,
    customerSuccessTeam: 73000,
    messagingCosts: 122371,
    stripeCharges: 31404,
    serverCosts: 27161,
    totalCOGS: 253937,
    profit: 779893,
    grossMargin: 75.44,
    gAndA: 50000,
    rAndD: 80000,
    salesTeam: 120000,
    marketingTotal: 18000,
    totalExpenses: 268000,
    netOperatingIncome: 511893,
  },
  {
    month: "Mar 27",
    date: "2027-03",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.80,
    locationsNeeded: 117,
    mrrAddedQuota: 35027,
    arrAddedQuota: 420328,
    monthlySMSIncome: 100000,
    monthlyRecurring: 956800,
    seasonalMisc: 50,
    setupFees: 22843,
    totalMonthlyIncome: 1079693,
    arr: 11481598,
    arrPlus: 12956317,
    customerSuccessTeam: 81000,
    messagingCosts: 125798,
    stripeCharges: 32346,
    serverCosts: 28161,
    totalCOGS: 267305,
    profit: 812388,
    grossMargin: 75.24,
    gAndA: 55000,
    rAndD: 80000,
    salesTeam: 140000,
    marketingTotal: 18000,
    totalExpenses: 293000,
    netOperatingIncome: 519388,
  },
  {
    month: "Apr 27",
    date: "2027-04",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.70,
    locationsNeeded: 118,
    mrrAddedQuota: 35402,
    arrAddedQuota: 424819,
    monthlySMSIncome: 100000,
    monthlyRecurring: 992201,
    seasonalMisc: 50,
    setupFees: 23688,
    totalMonthlyIncome: 1115940,
    arr: 11906417,
    arrPlus: 13391278,
    customerSuccessTeam: 81000,
    messagingCosts: 129320,
    stripeCharges: 33317,
    serverCosts: 19000,
    totalCOGS: 262637,
    profit: 853303,
    grossMargin: 76.46,
    gAndA: 54000,
    rAndD: 80000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 294000,
    netOperatingIncome: 559303,
  },
  {
    month: "May 27",
    date: "2027-05",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.60,
    locationsNeeded: 119,
    mrrAddedQuota: 35719,
    arrAddedQuota: 428631,
    monthlySMSIncome: 100000,
    monthlyRecurring: 1027921,
    seasonalMisc: 50,
    setupFees: 24541,
    totalMonthlyIncome: 1152512,
    arr: 12335048,
    arrPlus: 13830143,
    customerSuccessTeam: 81000,
    messagingCosts: 132941,
    stripeCharges: 34316,
    serverCosts: 19000,
    totalCOGS: 267257,
    profit: 885255,
    grossMargin: 76.81,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 309000,
    netOperatingIncome: 576255,
  },
  {
    month: "Jun 27",
    date: "2027-06",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.50,
    locationsNeeded: 120,
    mrrAddedQuota: 35977,
    arrAddedQuota: 431727,
    monthlySMSIncome: 100000,
    monthlyRecurring: 1063898,
    seasonalMisc: 50,
    setupFees: 25400,
    totalMonthlyIncome: 1189348,
    arr: 12766775,
    arrPlus: 14272177,
    customerSuccessTeam: 91000,
    messagingCosts: 136663,
    stripeCharges: 35346,
    serverCosts: 19000,
    totalCOGS: 282009,
    profit: 907339,
    grossMargin: 76.29,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 309000,
    netOperatingIncome: 598339,
  },
  {
    month: "Jul 27",
    date: "2027-07",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.40,
    locationsNeeded: 121,
    mrrAddedQuota: 36173,
    arrAddedQuota: 434070,
    monthlySMSIncome: 110000,
    monthlyRecurring: 1100070,
    seasonalMisc: 50,
    setupFees: 26264,
    totalMonthlyIncome: 1236384,
    arr: 13200845,
    arrPlus: 14836610,
    customerSuccessTeam: 91000,
    messagingCosts: 140490,
    stripeCharges: 36406,
    serverCosts: 19000,
    totalCOGS: 286896,
    profit: 949488,
    grossMargin: 76.80,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 309000,
    netOperatingIncome: 640488,
  },
  {
    month: "Aug 27",
    date: "2027-08",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.30,
    locationsNeeded: 121,
    mrrAddedQuota: 36302,
    arrAddedQuota: 435628,
    monthlySMSIncome: 110000,
    monthlyRecurring: 1136373,
    seasonalMisc: 50,
    setupFees: 27130,
    totalMonthlyIncome: 1273553,
    arr: 13636473,
    arrPlus: 15282638,
    customerSuccessTeam: 100000,
    messagingCosts: 144424,
    stripeCharges: 37498,
    serverCosts: 19000,
    totalCOGS: 300922,
    profit: 972631,
    grossMargin: 76.37,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 309000,
    netOperatingIncome: 663631,
  },
  {
    month: "Sep 27",
    date: "2027-09",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.20,
    locationsNeeded: 121,
    mrrAddedQuota: 36364,
    arrAddedQuota: 436367,
    monthlySMSIncome: 110000,
    monthlyRecurring: 1172737,
    seasonalMisc: 50,
    setupFees: 27999,
    totalMonthlyIncome: 1310785,
    arr: 14072841,
    arrPlus: 15729424,
    customerSuccessTeam: 100000,
    messagingCosts: 148468,
    stripeCharges: 38623,
    serverCosts: 19000,
    totalCOGS: 306091,
    profit: 1004695,
    grossMargin: 76.65,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 309000,
    netOperatingIncome: 695695,
  },
  {
    month: "Oct 27",
    date: "2027-10",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.10,
    locationsNeeded: 121,
    mrrAddedQuota: 36355,
    arrAddedQuota: 436258,
    monthlySMSIncome: 120000,
    monthlyRecurring: 1209092,
    seasonalMisc: 50,
    setupFees: 28867,
    totalMonthlyIncome: 1358008,
    arr: 14509099,
    arrPlus: 16296097,
    stateTaxes: 35000,
    customerSuccessTeam: 110000,
    messagingCosts: 152625,
    stripeCharges: 39782,
    serverCosts: 19000,
    totalCOGS: 321407,
    profit: 1036602,
    grossMargin: 76.33,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 344000,
    netOperatingIncome: 692602,
  },
  {
    month: "Nov 27",
    date: "2027-11",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 3.00,
    locationsNeeded: 121,
    mrrAddedQuota: 36273,
    arrAddedQuota: 435273,
    monthlySMSIncome: 120000,
    monthlyRecurring: 1245364,
    seasonalMisc: 50,
    setupFees: 29733,
    totalMonthlyIncome: 1395147,
    arr: 14944372,
    arrPlus: 16741762,
    customerSuccessTeam: 111000,
    messagingCosts: 156898,
    stripeCharges: 40975,
    serverCosts: 19000,
    totalCOGS: 327873,
    profit: 1067273,
    grossMargin: 76.50,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 309000,
    netOperatingIncome: 758273,
  },
  {
    month: "Dec 27",
    date: "2027-12",
    isProjection: true,
    aesActual: 8,
    monthlyMRRGrowthPct: 2.90,
    locationsNeeded: 120,
    mrrAddedQuota: 36116,
    arrAddedQuota: 433387,
    monthlySMSIncome: 170000,
    monthlyRecurring: 1281480,
    seasonalMisc: 50,
    setupFees: 30595,
    totalMonthlyIncome: 1482125,
    arr: 15377758,
    arrPlus: 17785496,
    customerSuccessTeam: 120000,
    messagingCosts: 161291,
    stripeCharges: 42205,
    serverCosts: 19000,
    totalCOGS: 342496,
    profit: 1139629,
    grossMargin: 76.89,
    gAndA: 54000,
    rAndD: 95000,
    salesTeam: 140000,
    marketingTotal: 20000,
    totalExpenses: 309000,
    netOperatingIncome: 830629,
  },
];

// Helper to format currency
export const formatCurrency = (value: number): string => {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`;
  return `$${value.toFixed(0)}`;
};

export const formatCurrencyFull = (value: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
};

// Get the last actual month's data
export const getLastActual = (): MonthData =>
  months.filter((m) => !m.isProjection).slice(-1)[0];

// Get the latest month's data
export const getLatest = (): MonthData => months.slice(-1)[0];

// The boundary month index (first projection)
export const projectionStartIndex = months.findIndex((m) => m.isProjection);
